module.exports = __webpack_public_path__ + "img/hot.56b1e189.png";